// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-mediumOnConfined-badge-f67e85af"};